<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <div>
          <b-card-title class="font-weight-bolder mb-1">
            Order Returns by SKU
          </b-card-title>
          <b-card-sub-title class="mb-25">
            which items are returned the most
          </b-card-sub-title>
        </div>
        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >Last Year
        </span>
      </b-card-header>

      <b-card-body>
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <!-- apex chart -->
        <vue-apex-charts
          v-else
          ref="chart"
          type="pie"
          height="325"
          class="mt-2 mb-1"
          :options="chartData.chartOptions"
          :series="chartData.series"
        />

        <!-- list group -->
        <div class="pt-25">
          <div
            v-for="(data, index) in chartData.listData"
            :key="index"
            class="d-flex justify-content-between"
            :class="
              index === Object.keys(chartData.listData).length - 1 ? '' : 'mb-1'
            "
          >
            <div class="series-info">
              <feather-icon
                :icon="data.icon"
                size="16"
                class="mr-50"
                :class="data.iconColor"
              />
              <span class="font-weight-bolder">{{ data.text }}</span>
            </div>
            <span>{{ data.result }}</span>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { LoadOnVisible } from '@/views/components/custom';
export default {
  components: {
    VueApexCharts,
    LoadOnVisible
  },
  data() {
    return {
      isLoadingChartData: true,
      chartData: {
        series: [1, 1, 1],
        chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          labels: [],
          dataLabels: {
            enabled: false
          },
          legend: { show: true, align: 'right' },
          stroke: {
            width: 4
          },
          // colors: [
          // ]
        }
      }
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  watch: {
    chartData: {
      handler: function(val) {
        // DOM updated
        if (this.$refs.chart) {
          this.$refs.chart.updateSeries(val.series, false, true);
        }
      },
      deep: true
    }
  },
  methods: {
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/analytics/order-returns-bysku')
        .then(resp => {
          let dataPoints = [];
          let legendPoints = [];
          let itemsToProc = resp.data.items;
          itemsToProc.forEach((itm) => {
            dataPoints.push(itm.quantityToReturn);
            legendPoints.push(itm.sku + ' ('+itm.quantityToReturn+')');
          });
          this.chartData.chartOptions.labels = legendPoints;
          this.chartData.series = dataPoints;
          this.isLoadingChartData = false;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.chartData.series = [0, 0, 0];
        });
    }
  },
  mounted() {
  }
};
</script>
